// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Welcome$ReactHooksTemplate = require("./Welcome.res.js");
var Substitution$ReactHooksTemplate = require("../common/Substitution.res.js");
var SurveyLanguage$ReactHooksTemplate = require("./surveyLanguage.res.js");

function WelcomeFormBhima(props) {
  var inlineButtonsLayout = props.inlineButtonsLayout;
  var __inlineButtonsSlot = props.inlineButtonsSlot;
  var __belowButtonsSlot = props.belowButtonsSlot;
  var __aboveButtonsSlot = props.aboveButtonsSlot;
  var __belowContentSlot = props.belowContentSlot;
  var __insideContentTopSlot = props.insideContentTopSlot;
  var substitutionVariables = props.substitutionVariables;
  var handleStart = props.handleStart;
  var textColor = props.textColor;
  var welcome = props.welcome;
  var $$default = props.default;
  var insideContentTopSlot = __insideContentTopSlot !== undefined ? Caml_option.valFromOption(__insideContentTopSlot) : null;
  var belowContentSlot = __belowContentSlot !== undefined ? Caml_option.valFromOption(__belowContentSlot) : null;
  var aboveButtonsSlot = __aboveButtonsSlot !== undefined ? Caml_option.valFromOption(__aboveButtonsSlot) : null;
  var belowButtonsSlot = __belowButtonsSlot !== undefined ? Caml_option.valFromOption(__belowButtonsSlot) : null;
  var inlineButtonsSlot = __inlineButtonsSlot !== undefined ? Caml_option.valFromOption(__inlineButtonsSlot) : null;
  var withDefault = function ($$default, x) {
    if (x.length === 0) {
      return $$default;
    } else {
      return x;
    }
  };
  var langName = SurveyLanguage$ReactHooksTemplate.name(props.language);
  var rawTitle = withDefault(Welcome$ReactHooksTemplate.title($$default), Welcome$ReactHooksTemplate.getTitleTranslation(welcome, langName));
  var rawDescription = withDefault(Welcome$ReactHooksTemplate.description($$default), Welcome$ReactHooksTemplate.getDescriptionTranslation(welcome, langName));
  var rawButton = withDefault(Welcome$ReactHooksTemplate.button($$default), Welcome$ReactHooksTemplate.getButtonTranslation(welcome, langName));
  var titleHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawTitle, substitutionVariables);
  var descriptionHtml = Substitution$ReactHooksTemplate.renderQuestionText(rawDescription, substitutionVariables);
  var buttonText = Substitution$ReactHooksTemplate.substituteVariables(rawButton, substitutionVariables);
  var hasDescription = rawDescription.trim() !== "";
  var buttonElement = JsxRuntime.jsx("a", {
        children: buttonText,
        className: "text-black text-18-px font-semibold py-4 px-8 text-center rounded shadow-sm",
        style: {
          backgroundColor: props.buttonBgColor
        },
        href: "#",
        onClick: (function ($$event) {
            $$event.preventDefault();
            Curry._1(handleStart, undefined);
          })
      });
  var buttonSection = inlineButtonsLayout !== undefined ? (
      inlineButtonsLayout === "InlineLeft" ? JsxRuntime.jsxs("div", {
              children: [
                inlineButtonsSlot,
                buttonElement
              ],
              className: "flex items-stretch gap-3"
            }) : JsxRuntime.jsxs("div", {
              children: [
                inlineButtonsSlot,
                buttonElement
              ],
              className: "flex items-stretch gap-3 flex-row-reverse"
            })
    ) : JsxRuntime.jsxs("div", {
          children: [
            aboveButtonsSlot,
            buttonElement,
            belowButtonsSlot
          ],
          className: "w-full flex flex-col gap-3 items-center"
        });
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("img", {
                            src: Image$ReactHooksTemplate.bhimaThankyou
                          }),
                      insideContentTopSlot,
                      JsxRuntime.jsx("div", {
                            className: "survey-rich-text text-" + textColor + " text-xl text-center small:text-lg uppercase leading-snug",
                            dangerouslySetInnerHTML: {
                              __html: titleHtml
                            }
                          }),
                      hasDescription ? JsxRuntime.jsx("div", {
                              className: "survey-rich-text text-" + textColor + " text-l text-center small:text-sm leading-relaxed",
                              dangerouslySetInnerHTML: {
                                __html: descriptionHtml
                              }
                            }) : null,
                      JsxRuntime.jsx("div", {
                            children: belowContentSlot,
                            className: "w-full flex justify-center"
                          }),
                      buttonSection
                    ],
                    className: "flex flex-col items-center px-80-px small:px-6 w-full gap-4 py-4"
                  }),
              className: "flex w-full flex-col justify-center flex-grow"
            });
}

var make = WelcomeFormBhima;

exports.make = make;
/* react/jsx-runtime Not a pure module */
